import Background from 'formstone/jquery/background';
import Checkpoint from 'formstone/jquery/checkpoint';
import Lightbox from 'formstone/jquery/lightbox';
import Mediaquery from 'formstone/jquery/mediaquery';
import Navigation from 'formstone/jquery/navigation';
import Swap from 'formstone/jquery/swap';

window.SiteReady(($) => {
  console.log('Init: Main Site');

  let $window = $(window);
  let $body = $('body');


  // Tables

  $('.wp-block-table').find('table').wrap('<div class="table_wrapper"></div>');

  // footer social links // added on menu.php line 172 instead of here

  // $('.external a').attr('target', '_blank');


  // Scroll

  let newScroll = -1;
  let lastScroll = 0;
  let newShift = -1;
  let lastShift = 100;

  function onScroll() {
    newScroll = $window.scrollTop();
    newShift = newScroll;
  }

  function onRAF() {
    if (newScroll != lastScroll) {
      let scrollDir = (newScroll < lastScroll) ? 'up' : 'down';

      if (newScroll > 0) {
        $body.addClass('scrolled');
      } else {
        $body.removeClass('scrolled');
      }

      if (newScroll > 200) {
        if (scrollDir == 'down') {
          if (newShift - lastShift > 80) {
            $body.addClass('shifted');

            lastShift = newShift;
          }
        } else {
          if (lastShift - newShift > 80) {
            $body.removeClass('shifted');

            lastShift = newShift;
          }
        }
      }

      lastScroll = newScroll;
    }

    window.requestAnimationFrame(onRAF);
  }

  $window.on('scroll', onScroll);
  window.requestAnimationFrame(onRAF);

  onScroll();



  // Corporate Nav Replacements

  let $corpNav = $('.js-corporate_nav');
  let $corpNavTop = $corpNav.find('.menu > li');

  $('.js-replacement_nav').each((i, el) => {
    let $target = $(el);
    let $find = $target.find('.menu > li.replace_corporate');

    $find.each((ii, item) => {
      let $item = $(item);
      let label = $item.find('> a').text();

      $corpNavTop.each((iii, corpItem) => {
        let $corpItem = $(corpItem);
        let corpLabel = $corpItem.find('> a').text();

        if (label.trim().toLowerCase() == corpLabel.trim().toLowerCase()) {
          $item.replaceWith( $corpItem.clone() );
        }
      });
    });

  });

  // Desktop Nav

  $('.js-header_menu_handles li.menu-item-has-children').on('mouseenter focusin', (e) => {
    let $el = $(e.currentTarget);

    $('.js-header_menu_handles li').removeClass('open');

    $el.addClass('open');
  }).on('mouseleave focusout', (e) => {
    $('.js-header_menu_handles li').removeClass('open');
  });

  // function openMenu(id) {
  //   $('#menu-item-' + id).addClass('open');
  //   $('.js-header_menu-' + id).addClass('open');
  //   $('.js-header').addClass('open');
  //   $('.js-header_expand').attr('aria-hidden', null);
  // }

  // function closeMenus() {
  //   $('.js-header_menu_handles li, .js-header_menu').removeClass('open');
  //   $('.js-header').removeClass('open');
  //   $('.js-header_expand').attr('aria-hidden', 'true');
  // }


  // Mobile Nav

  $('.js-mobile_menu .menu > .menu-item-has-children > a').each((index, el) => {
    let $link = $(el);
    let active = ($link.parent('li').hasClass('current-menu-ancestor') || $link.parent('li').hasClass('current_page_item'));
    let html = '';
    let linkClass = 'js-nav_toggle_' + index;

    html += '<span class="toggle_handle js-swap js-nav_toggle';
    if (active) {
      linkClass += ' fs-swap-active';
      html += ' fs-swap-active';
    }
    html += '" data-swap-target=".js-nav_toggle_' + index + '"';
    if (active) {
      html += ' data-swap-active="true"';
    }
    // html += ' data-swap-options="{&quot;maxWidth&quot;:&quot;979px&quot;}"';
    html += '></span>';

    $link.append(html).next('ul').addClass(linkClass);
  });

  $('.js-mobile_menu').on('navigation:open', function() {
    $('.js-mobile_menu').scrollTop(0);
  });


  // Videos

  function initVideoPlayer($target) {
    let player = $target.data('videoPlayer');

    if (typeof player == 'undefined') {
      let $iframe = $target.find('.js-video_player');
      let src = $iframe.attr('src');

      if (typeof src == 'undefined') {
        $iframe.attr('src', $iframe.data('src'));
      }

      $target.data('videoPlayer', $iframe);
    }
  }

  // if ($('.js-video_modal, .js-video_swap').length > 0 && $('script[src*="youtube.com/iframe_api"]').length == 0) {
  //   $('head').append('<script src="//www.youtube.com/iframe_api"></script>');
  // }

  // let originalYouTubeCallback = window.onYouTubeIframeAPIReady || null; // Fixes background race condition

  // window.onYouTubeIframeAPIReady = () => {
  //   if (typeof originalYouTubeCallback == 'function') {
  //     originalYouTubeCallback();
  //   }
  // }

  // $('.js-video_swap, .js-video_modal').each((index, el) => {
  //   initVideoPlayer($(el));
  // });

  // $('.js-video_swap, .js-video_modal').on('swap:activate', (e) => {
  //   let $target = $(e.currentTarget);
  //   let $iframe = $target.find('.js-video_player');

  //   $iframe[0].contentWindow.postMessage(JSON.stringify({method:"play"}), '*');
  //   // $iframe[0].contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');

  //   let windowWidth = window.innerWidth;

  //   if (windowWidth < 740) {
  //     document.documentElement.requestFullscreen();
  //   }
  // }).on('swap:deactivate', (e) => {
  //   let $target = $(e.currentTarget);
  //   let $iframe = $target.find('.js-video_player');


  //   $iframe[0].contentWindow.postMessage(JSON.stringify({method:"pause"}), '*');
  //   // $iframe[0].contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');

  //   if (document.fullscreenElement != null) {
  //     document.exitFullscreen();
  //   }
  // });


  // // Filter Groups

  // $('.js-filter_group .js-filter_button').on('click', (e) => {
  //   let $target = $(e.currentTarget);
  //   let $parent = $target.parents('.js-filter_group');
  //   let $buttons = $parent.find('.js-filter_button');
  //   // let $select = $parent.find('.js-filter_select');
  //   let $items = $parent.find('.js-filter_item');
  //   let active = $target.data('filter');

  //   $buttons.removeClass('active');
  //   $target.addClass('active');

  //   if (active == 'all') {
  //     $items.show();
  //   } else {
  //     $items.hide().filter('[data-filter="' + active + '"]').show();
  //   }
  // });

  // $('.js-filter_group .js-filter_select').on('change', (e) => {
  //   let $target = $(e.currentTarget);
  //   let $parent = $target.parents('.js-filter_group');
  //   let $buttons = $parent.find('.js-filter_button');
  //   let active = $target.val();

  //   $buttons.filter('[data-filter="' + active + '"]').trigger('click');
  // });


  // Filters

  $('.js-jump_form').on('submit', (e) => {
    e.preventDefault();
    e.stopPropagation();
  });

  $('.js-jump_select').on('change', (e) => {
    let val = $(e.currentTarget).val();

    window.location.href = val;
  });

  $('.js-filter_form select').on('change', (e) => {
    let $target = $(e.currentTarget);

    $target.parents('form').submit();

    // let url = $(this).val();
    // window.location.href = url;
  });


  // // Scroll Next

  // $('.js-scroll_next').on('click', (e) => {
  //   e.preventDefault();
  //   e.stopPropagation();

  //   let $parent = $(e.currentTarget).parents('.js-scroll_next_parent');
  //   let $next = $parent.next();

  //   if ($next.length) {
  //     window.scrollToElement($next);
  //   }
  // });


  // Search Modal

  $('.js-search_modal').on('swap:activate', (e) => {
    let $target = $(e.currentTarget);

    setTimeout(() => {
      $target.find('input[type="text"]').first().focus();
    }, 50);
  });


  // Action bar resize

  $(window).on('resize', (e) => {
    let $header = $('.header');
    let margin = $header[0].offsetHeight + 20;

    $('body')[0].style.setProperty('--scrol-margin', margin + 'px');

    let $bars = $('.action_bar');

    $bars.each((index, el) => {
      let height = el.firstChild.offsetHeight;

      el.style.setProperty('--action_bar_height', height + 'px');
    });
  }).trigger('resize');


  $('.js-lightbox_gallery').each((index, el) => {
    let $gallery = $(el);
    let $items = $gallery.find('.js-lightbox_gallery_item').not('.splide__slide--clone');
    let html = '<div class="screenreader">';

    $items.each((i, item) => {
      let $item = $(item);
      let gallery = $item.data('lightbox-gallery');
      let galleryId = gallery + '-clone';
      let galleryItem = gallery + '-item_' + (i + 1);

      $item.attr('data-gallery-linked', galleryItem);

      html += '<a href="' + $item.attr('href') + '" class="js-lightbox" data-lightbox-gallery="' + galleryId + '" id="' + galleryItem + '">Gallery Item ' + (i + 1) + '</a>';
    });

    html += '</div>';

    $gallery.append(html);
  });

  $('.js-lightbox_gallery').on('click', '.js-lightbox_gallery_item', (e) => {
    e.preventDefault();
    e.stopPropagation();

    let $item = $(e.currentTarget);
    let id = $item.data('gallery-linked');

    // $('#' + id).trigger('click');
    $('#' + id)[0].click();
    // simulateClick($('#' + id)[0]);
    // console.log($('#' + id));
  });


  // Cookies

  let cookieCheck = localStorage.getItem( 'benedictine-cookie-notice' );

  if ( ! cookieCheck || cookieCheck !== 'closed' ) {
    $('.js-cookie_notice').show();
  }

  $('.js-cookie_notice button').on('click', (e) => {
    $('.js-cookie_notice').remove();

    localStorage.setItem( 'benedictine-cookie-notice', 'closed' );
  });


  // Plugins

  $('.js-navigation').navigation();
  $('.js-background').background();
  $('.js-swap').swap();
  $('.js-lightbox').lightbox();
  // $('.js-tabs').tabs();

  $('.js-checkpoint, [data-checkpoint-animation]').checkpoint({
    offset: '100px',
    reverse: true
  });

});


// var simulateClick = function(el) {
//   var evt = new MouseEvent('click', {
//     bubbles: true,
//     cancelable: true,
//     view: window
//   });
//   var canceled = !el.dispatchEvent(evt);
// };